import { logWrapper } from '../../utils';
import { UAParser } from 'ua-parser-js';
import moment from 'moment';
import * as pdfjsLib from 'pdfjs-dist';

export default {
  signedDocumentSealController: [
    'runtimeConstant',
    'webApiSettings',
    '$scope',
    '$rootScope',
    '$location',
    '$uibModal',
    'revisions',
    'signedDocumentSealService',
    'extensionInstallService',
    'authService',
    '$state',
    function (
      runtimeConstant,
      webApiSettings,
      $scope,
      $rootScope,
      $location,
      uibModal,
      revisions,
      service,
      extensionInstallService,
      authService,
      $state
    ) {
      'use strict';

      function startSigningProgress() {
        $scope.error = undefined;
        $scope.signStep = 0;
        $scope.isSigningInProgress = true;
      }

      function setSigningStep(step) {
        $scope.signStep = step;
        $scope.$applyAsync();
      }

      function finishSigningProgress() {
        $scope.signStep = 3;
        $scope.$applyAsync();
      }

      function cancelSigningProgress() {
        $scope.isSigningInProgress = false;
        $scope.signStep = 0;
      }

      function legacy_init() {
        if ($scope.debug) window.hwcrypto.debug();

        if (!window.hwcrypto.use($scope.backend)) {
          $scope.error = 'no_implementation';
          return false;
        }
      }

      function legacy_getCertificate() {
        window.hwcrypto
          .getCertificate({ lang: $scope.lang })
          .then(function (response) {
            $scope.certificate = response;
            $scope.setSigningStep(1);
            $scope.legacy.getHashes();
          })
          .catch(function (error) {
            $scope.error = error.message;
            $scope.cancelSigningProgress();
            if ($scope.error === 'user_cancel') {
              $scope.error = undefined;
              $scope.isShowSeal = true;
            }
            if ($scope.error === 'no_implementation')
              $scope.error = 'install_legacy';
            $scope.$applyAsync();
          });
      }

      function legacy_getHashes() {
        var docs = [];

        for (var i = 0, len = revisions[0].length; i < len; i++) {
          var r = revisions[0][i];
          docs.push({
            id: !r.isHistory ? r.id : r.idRevisionHistory,
            extension: r.extension,
            certificate: $scope.certificate.hex,
            isSigned: r.isSigned === undefined ? false : r.isSigned,
            inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
            isHistory: r.isHistory,
            positionX: $scope.confirmedSeal[0].x,
            positionY: $scope.confirmedSeal[0].y,
            positionPage: $scope.confirmedSeal[0].page,
            isVisibleSign: true,
            logo: $scope.logoCompany,
            titleSign: 'Documento assinado digitalmente',
          });
        }

        service
          .getHashes(docs)
          .then(function (response) {
            $scope.documentHashs = response;
            $scope.setSigningStep(2);
            $scope.legacy.signDocuments();
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.cancelSigningProgress();
            $scope.isShowSeal = true;
            $scope.$applyAsync();
          });
      }

      function legacy_signDocuments(index) {
        if (index === undefined) index = 0;
        var docInfo = $scope.documentHashs[index];

        docInfo.PositionX = $scope.confirmedSeal[0].x;
        docInfo.PositionY = $scope.confirmedSeal[0].y;
        docInfo.PositionPage = $scope.confirmedSeal[0].page;
        docInfo.IsVisibleSign = true;
        docInfo.Logo = $scope.logoCompany;
        docInfo.TitleSign = 'Documento assinado digitalmente';

        var hash = { type: $scope.hashType, hex: docInfo.Hash };
        var confs = { lang: $scope.lang };

        window.hwcrypto
          .sign($scope.certificate, hash, confs)
          .then(function (response) {
            docInfo.signature = response.hex;

            var r = !docInfo.IsHistory
              ? revisions[0].filter((r) => r.id === docInfo.Id)
              : revisions[0].filter((r) => r.idRevisionHistory === docInfo.Id);

            docInfo.inFlow = r.IdWorkflow !== undefined && r.IdWorkflow !== null;

            service
              .finalizeSignature(docInfo)
              .then(function () {
                docInfo.IsSigned = true;
                $scope.updateRevisions();
                $scope.finishSigningProgress();
              })
              .catch(function (error) {
                $scope.error = error;
                $scope.cancelSigningProgress();
                $scope.isShowSeal = true;
                $scope.$applyAsync();
              });
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.cancelSigningProgress();
            if ($scope.error === 'no_implementation')
              $scope.error = 'install_legacy';
            if (
              $scope.error === 'user_cancel' ||
              $scope.error.message === 'technical_error'
            ) {
              $scope.error = undefined;
              $scope.isShowSeal = true;
            }
            $scope.$applyAsync();
          });
      }

      function base64toHEX(base64) {
        var raw = atob(base64);
        var HEX = '';

        for (var i = 0; i < raw.length; i++) {
          var _hex = raw.charCodeAt(i).toString(16);
          HEX += _hex.length === 2 ? _hex : '0' + _hex;
        }

        return HEX.toUpperCase();
      }

      function hexToBase64(str) {
        return btoa(
          String.fromCharCode.apply(
            null,
            str
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
          )
        );
      }

      function webeid_init() {}

      function webeid_getCertificate() {
        var parser = new UAParser();
        extensionInstallService
          .validateAndInstall(parser)
          .then(function () {
            extensionInstallService
              .getCertificate()
              .then(function (response) {
                $scope.certificate = response;
                $scope.setSigningStep(1);
                $scope.webeid.getHashes();
              })
              .catch(function (error) {
                $scope.error = error.message;
                $scope.cancelSigningProgress();

                if ($scope.error === 'user_cancel') {
                  $scope.error = undefined;
                  $scope.isShowSeal = true;
                }

                if ($scope.error === 'no_implementation')
                  $scope.webeid.checkExtension();
                $scope.$applyAsync();
              });
          })
          .catch(function () {
            $scope.error = 'no_implementation';
            $scope.cancelSigningProgress();
            $scope.webeid.checkExtension();
          });
      }

      function webeid_getHashes() {
        var docs = [];

        if (revisions[0].length) {
          for (var i = 0; i < revisions[0].length; i++) {
            var r = revisions[0][i];

            var pX = $scope.confirmedSeal[0].x;
            var rectWidth = $scope.confirmedSeal[0].rectWidth;
            var pY = $scope.confirmedSeal[0].y;
            var rectHeight = $scope.confirmedSeal[0].rectHeight;

            var pageInfo = $scope.pages[$scope.confirmedSeal[0].page - 1];
            var x = pX * (pageInfo.originalWidth / rectWidth);
            var y = pY * (pageInfo.originalHeight / rectHeight);

            docs.push({
              id: !r.isHistory ? r.id : r.idRevisionHistory,
              extension: r.extension,
              certificate: $scope.base64toHEX($scope.certificate),
              isSigned: r.isSigned === undefined ? false : r.isSigned,
              inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
              isHistory: r.isHistory,
              positionX: x,
              positionY: y,
              positionPage: $scope.confirmedSeal[0].page,
              isVisibleSign: true,
              logo: $scope.logoCompany,
              titleSign: 'Documento assinado digitalmente',
            });
          }
        } else {
          var r = revisions[0];
          docs.push({
            id: !r.isHistory ? r.id : r.idRevisionHistory,
            extension: r.extension,
            certificate: $scope.base64toHEX($scope.certificate),
            isSigned: r.isSigned === undefined ? false : r.isSigned,
            inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
            isHistory: r.isHistory,
            positionX: $scope.confirmedSeal[0].x,
            positionY: $scope.confirmedSeal[0].y,
            positionPage: $scope.confirmedSeal[0].page,
            isVisibleSign: true,
            logo: $scope.logoCompany,
            titleSign: 'Documento assinado digitalmente',
          });
        }

        service
          .getHashes(docs)
          .then(function (response) {
            $scope.documentHashs = response;
            $scope.setSigningStep(2);
            $scope.webeid.signDocuments();
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.cancelSigningProgress();
            $scope.isShowSeal = true;
            $scope.$applyAsync();
          });
      }

      function webeid_signDocuments(index) {
        if (index === undefined) index = 0;

        var docInfo = $scope.documentHashs[index];

        var pX = $scope.confirmedSeal[0].x;
        var rectWidth = $scope.confirmedSeal[0].rectWidth;
        var pY = $scope.confirmedSeal[0].y;
        var rectHeight = $scope.confirmedSeal[0].rectHeight;

        var pageInfo = $scope.pages[$scope.confirmedSeal[0].page - 1];
        var x = pX * (pageInfo.originalWidth / rectWidth);
        var y = pY * (pageInfo.originalHeight / rectHeight);

        docInfo.PositionX = x;
        docInfo.PositionY = y;
        docInfo.PositionPage = $scope.confirmedSeal[0].page;
        docInfo.IsVisibleSign = true;
        docInfo.Logo = $scope.logoCompany;
        docInfo.TitleSign = 'Documento assinado digitalmente';

        $scope.totalDocuments = $scope.documentHashs.length;
        $scope.currentIndex = index + 1 + '';

        extensionInstallService
          .sign($scope.certificate, $scope.hexToBase64(docInfo.Hash))
          .then(function (response) {
            docInfo.signature = $scope.base64toHEX(response);

            var r = {};
            if (!docInfo.IsHistory) {
              r = revisions[0].length
                ? revisions[0].filter((r) => r.id === docInfo.Id)
                : (r = revisions[0]);
            } else {
              r = revisions[0].filter(
                (r) => r.idRevisionHistory === docInfo.Id
              );
            }
            docInfo.inFlow = r.IdWorkflow !== undefined && r.IdWorkflow !== null;

            service
              .finalizeSignature(docInfo)
              .then(function () {
                docInfo.IsSigned = true;
                $scope.updateRevisions();
                $scope.finishSigningProgress();
              })
              .catch(function (error) {
                $scope.error = error;
                $scope.cancelSigningProgress();
                $scope.isShowSeal = true;
                $scope.$applyAsync();
              });
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.cancelSigningProgress();

            if ($scope.error === 'no_implementation')
              $scope.webeid.checkExtension();
            if (
              $scope.error === 'user_cancel' ||
              $scope.error.message === 'technical_error' ||
              $scope.error.message === 'invalid_argument'
            ) {
              $scope.error = undefined;
              $scope.isShowSeal = true;
            }

            $scope.$applyAsync();
          });
      }

      function webeid_installFirefox() {
        extensionInstallService.firefoxInstall().then(function () {
          $scope.init();
        });
      }

      function webeid_checkExtension() {
        var parser = new UAParser();
        var b = parser.getBrowser();
        extensionInstallService
          .validateAndInstall(parser)
          .then(function () {
            $scope.init();
          })
          .catch(function (err) {
            if (err.error) {
              $scope.downloadInfo = err.downloadInfo;
              $scope.extensionError = err.error;
            } else {
              $scope.extensionError = err;
            }

            $scope.browser = b.name;
            $scope.$applyAsync();
          });
      }

      function selectEngine() {
        var parser = new UAParser();
        var b = parser.getBrowser();

        if (
          navigator.userAgent.indexOf('MSIE') !== -1 ||
          navigator.userAgent.indexOf('Trident') !== -1
        ) {
          $scope.engine = $scope.legacy;
        } else if (
          ['Chrome', 'Firefox', 'Opera', 'Vivaldi'].indexOf(b.name) !== -1
        ) {
          $scope.engine = $scope.webeid;
        } else {
          $scope.engine = $scope.legacy;
        }

        $scope.engine.init();
      }

      function updateRevisions() {
        for (var i = 0, len = $scope.documentHashs.length; i < len; i++) {
          var info = $scope.documentHashs[i];
          var r = revisions[0].length
            ? revisions[0].filter((r) => r.id === info.Id)[0]
            : revisions[0];
          r.isSigned = info.IsSigned;
          if (r.isSigned && !r.extension.endsWith('p7s')) {
            r.extension =
              info.Extension === 'pdf' && !info.SignPdfAsP7s
                ? 'pdf'
                : r.extension + '.p7s';
          }
        }
      }

      function confirmSeal() {
        $scope.error = undefined;
        $scope.extensionError = undefined;

        if ($scope.seal.length === 0) {
          console.warn('⚠️ Nenhum selo para confirmar.');
          return;
        }

        var confirmedSeal = angular.copy($scope.seal);
        var pageInfo = $scope.pages[confirmedSeal[0].page - 1];

        var sealData = {
          positionX: confirmedSeal[0].x * (pageInfo.originalWidth / confirmedSeal[0].rectWidth),
          positionY: confirmedSeal[0].y * (pageInfo.originalHeight / confirmedSeal[0].rectHeight),
          positionPage: confirmedSeal[0].page,
          isVisibleSign: true,
          logo: $scope.logoCompany,
          titleSign: 'Documento assinado digitalmente',
        };

        if (document.activeElement && document.activeElement.blur) {
          document.activeElement.blur();
        }

        $scope.$close(false);

        var modalInstance = uibModal.open({
          animationEnabled: true,
          backdrop: 'static',
          templateUrl: '/views/modules/signing/signDocumentPartial.html',
          controller: 'signDocumentsController',
          windowClass: 'sign-modal-window',
          resolve: {
            revisions: function () {
              return revisions;
            },
            inFlow: function () {
              return false;
            },
            sealData: function () {
              return sealData;
            },
          },
        });

        modalInstance.result.then(function (success) {
          if (success) {
            $state.reload();
          }
        });
      }

      function resetSeal() {
        $scope.seal = [];
        $scope.confirmedSeal = [];

        for (let i = 1; i <= $scope.pages.length; i++) {
          var canvas = document.getElementById(`pdf-canvas-${i}`);
          if (!canvas) {
            // eslint-disable-next-line no-console
            console.warn(`Canvas pdf-canvas-${i} não encontrado no reset.`);
            continue;
          }

          var context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);

          setTimeout(() => {
              $scope.renderPage(
                  $scope.pdfInstance,
                  i,
                  `pdf-canvas-${i}`
              );
          }, 0);
        }
      }

      function renderPage(pdf, pageNumber, canvasId) {
        pdf.getPage(pageNumber).then(function (page) {
          var canvas = document.getElementById(canvasId);
          if (!canvas) return;

          if (canvas._renderTask) {
            canvas._renderTask.cancel();
            canvas._renderTask = null;
          }

          var context = canvas.getContext('2d');
          var container = document.querySelector('.preview-doc');
          var maxWidth = container.clientWidth - 50;
          var viewport = page.getViewport({ scale: 1 });
          var scale = maxWidth / viewport.width;
          var scaledViewport = page.getViewport({ scale: scale });

          canvas.width = scaledViewport.width;
          canvas.height = scaledViewport.height;

          canvas.style.width = scaledViewport.width + 'px';
          canvas.style.height = scaledViewport.height + 'px';

          $scope.$applyAsync(function () {
            $scope.pages[pageNumber - 1] = {
              width: scaledViewport.width,
              height: scaledViewport.height,
              originalWidth: viewport.width,
              originalHeight: viewport.height,
              scale: scale,
            };
            $scope.pdfScale = scale;
          });

          var renderTask = page.render({
            canvasContext: context,
            viewport: scaledViewport,
          });

          canvas._renderTask = renderTask;

          renderTask.promise
            .then(function () {
              canvas._renderTask = null;
            })
            .catch(function () {
              // render cancelado — ignorar
            });
        });
      }

      function loadPDF(url) {
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.10.111/pdf.worker.min.js';

        pdfjsLib
          .getDocument(url)
          .promise.then(function (pdf) {
            $scope.pdfInstance = pdf;
            $scope.pages = [];

            for (let i = 0; i < pdf.numPages; i++) {
              $scope.pages.push({ width: 0, height: 0 });
            }

            $scope.$applyAsync();

            setTimeout(() => {
              for (let i = 1; i <= pdf.numPages; i++) {
                $scope.renderPage($scope.pdfInstance, i, `pdf-canvas-${i}`);
              }
            }, 0);
          })
          .catch(function (error) {
            // eslint-disable-next-line no-console
            console.error('Error loading PDF:', error);
          });
      }

      function loadPDFBase64(base64String) {
        var base64Data = base64String.replace(
          /^data:application\/pdf;base64,/,
          ''
        );
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'application/pdf' });
        var pdfUrl = URL.createObjectURL(blob);
        $scope.loadPDF(pdfUrl);
      }

      function convertImageToBase64(path, callback) {
        fetch(path)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => callback(reader.result);
            reader.readAsDataURL(blob);
          });
      }

      function init() {
        if (webApiSettings.detailsCompany === 'hdoc') {
          $scope.icCompany = '/assets/images/hdoc_seal.png';
        } else if (webApiSettings.detailsCompany === 'digitaldoc') {
          $scope.icCompany = '/assets/images/dd_seal.png';
        }

        convertImageToBase64($scope.icCompany, (base64) => {
          $scope.logoCompany = base64;
          $scope.$applyAsync();
        });

        var documentData = {
          extension: revisions[0][0].extension.toLowerCase(),
          id: revisions[0][0].id,
          idCompany: revisions[0][0].idCompany,
          isHistory: revisions[0][0].isHistory,
          pageCount: revisions[0][0].numberOfPages,
          rowGuid: revisions[0][0].guid,
          server: webApiSettings.viewerServer,
          title: revisions[0][0].title,
          userId: authService.user.id
        };

        service
          .getSealDocument(documentData)
          .then(function (response) {
            $scope.loadPDFBase64(response);
            $scope.isShowSeal = true;
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error('err: ', err);
          });
      }

      function run() {
        try {
          $scope.logoCompany = '';
          $scope.icCompany = '/assets/images/dd_seal.png';
          $scope.pages = new Array(5);
          $scope.seal = [];
          $scope.confirmedSeal = [];
          $scope.currentDateTimeAction = moment().format('DD/MM/YYYY HH:mm:ss Z');
          $scope.pdfScale = 1;
          $scope.rectWidth = 0;
          $scope.rectHeight = 0;
          $scope.isShowSeal = false;

          $scope.isSigningInProgress = false;
          $scope.signStep = 0;

          $scope.error = undefined;
          $scope.extensionError = undefined;
          $scope.engine = undefined;
          $scope.legacyUrl =
            'https://installer.id.ee/media/win/Open-EID-21.6.0.1912_x86.exe';

          var url = $location.absUrl();
          $scope.env =
            url.indexOf('localhost') !== -1
              ? 'localhost'
              : url.indexOf('digitaldoc.com.br') !== -1
              ? 'production'
              : 'dev';

          $scope.hashType = 'SHA-1';
          $scope.backend = 'auto';
          $scope.lang = 'en';
          $scope.debug = true;
          $scope.certificate = null;
          $scope.documentHashs = null;
          $scope.webeid = {};
          $scope.legacy = {};

          $scope.legacy.init = logWrapper(legacy_init, runtimeConstant.isDebugControllersInternals);
          $scope.legacy.getCertificate = logWrapper(legacy_getCertificate, runtimeConstant.isDebugControllersInternals);
          $scope.legacy.getHashes = logWrapper(legacy_getHashes, runtimeConstant.isDebugControllersInternals);
          $scope.legacy.signDocuments = logWrapper(legacy_signDocuments, runtimeConstant.isDebugControllersInternals);
          $scope.base64toHEX = logWrapper(base64toHEX, runtimeConstant.isDebugControllersInternals);
          $scope.hexToBase64 = logWrapper(hexToBase64, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.init = logWrapper(webeid_init, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.getCertificate = logWrapper(webeid_getCertificate, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.getHashes = logWrapper(webeid_getHashes, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.signDocuments = logWrapper(webeid_signDocuments, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.installFirefox = logWrapper(webeid_installFirefox, runtimeConstant.isDebugControllersInternals);
          $scope.webeid.checkExtension = logWrapper(webeid_checkExtension, runtimeConstant.isDebugControllersInternals);
          $scope.selectEngine = logWrapper(selectEngine, runtimeConstant.isDebugControllersInternals);
          $scope.updateRevisions = logWrapper(updateRevisions, runtimeConstant.isDebugControllersInternals);
          $scope.confirmSeal = logWrapper(confirmSeal, runtimeConstant.isDebugControllersInternals);
          $scope.resetSeal = logWrapper(resetSeal, runtimeConstant.isDebugControllersInternals);
          $scope.renderPage = logWrapper(renderPage, runtimeConstant.isDebugControllersInternals);
          $scope.loadPDF = logWrapper(loadPDF, runtimeConstant.isDebugControllersInternals);
          $scope.loadPDFBase64 = logWrapper(loadPDFBase64, runtimeConstant.isDebugControllersInternals);
          $scope.startSigningProgress = logWrapper(startSigningProgress, runtimeConstant.isDebugControllersInternals);
          $scope.setSigningStep = logWrapper(setSigningStep, runtimeConstant.isDebugControllersInternals);
          $scope.finishSigningProgress = logWrapper(finishSigningProgress, runtimeConstant.isDebugControllersInternals);
          $scope.cancelSigningProgress = logWrapper(cancelSigningProgress, runtimeConstant.isDebugControllersInternals);
          $scope.init = logWrapper(init, runtimeConstant.isDebugControllersInternals);

        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
